import template from './creditworthiness.html';
import controller from './creditworthiness.controller';
import './creditworthiness.scss';

let creditworthinessComponent = {
  restrict: 'E',
  bindings: {
    serviceClosed: '<'
  },
  template,
  controller
};

export default creditworthinessComponent;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthiness.component.js